/* OEST Routes: ride-type filters, route cards that open as a centred dialog, photo carousel, Strava map. */
(function () {
  var STRAVA_JS = 'https://strava-embeds.com/embed.js';
  var stravaLoading = null;

  function loadStravaScript() {
    if (window.__STRAVA_EMBED_BOOTSTRAP__) return Promise.resolve();
    if (stravaLoading) return stravaLoading;
    stravaLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = STRAVA_JS;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return stravaLoading;
  }

  // Plain iframe used if Strava's (undocumented) bootstrap is unavailable.
  function fallbackIframe(slot, id, title) {
    var f = document.createElement('iframe');
    f.src = 'https://strava-embeds.com/route/' + id + '?fullWidth=true&style=standard&surfaceType=true&fromEmbed=true';
    f.title = title;
    f.setAttribute('frameborder', '0');
    f.style.height = '560px';
    slot.replaceChildren(f);
  }

  function loadMap(slot) {
    if (!slot || slot.dataset.loaded) return;
    slot.dataset.loaded = 'true';
    var id = slot.dataset.routeId;
    var title = (slot.dataset.routeTitle || 'Route') + ' – Strava route map';
    var ph = document.createElement('div');
    ph.className = 'strava-embed-placeholder';
    ph.dataset.embedType = 'route';
    ph.dataset.embedId = id;
    ph.dataset.fullWidth = 'true';
    ph.dataset.style = 'standard';
    ph.dataset.surfaceType = 'true';
    ph.dataset.fromEmbed = 'true';
    slot.replaceChildren(ph);
    slot.classList.add('is-loading');

    loadStravaScript().then(function () {
      if (slot.querySelector('.strava-embed-placeholder') && window.__STRAVA_EMBED_BOOTSTRAP__) {
        window.__STRAVA_EMBED_BOOTSTRAP__();
      }
      var frame = slot.querySelector('iframe');
      if (frame) frame.title = title;
      else fallbackIframe(slot, id, title);
      slot.classList.remove('is-loading');
    }).catch(function () {
      fallbackIframe(slot, id, title);
      slot.classList.remove('is-loading');
    });
  }

  function initCarousel(car) {
    if (car.dataset.ready) return;
    car.dataset.ready = 'true';
    var track = car.querySelector('.rt-carousel__track');
    var slides = track.children;
    var dots = car.querySelectorAll('.rt-carousel__dots span');
    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    var prev = car.querySelector('[data-carousel-prev]');
    var next = car.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    track.addEventListener('scroll', function () {
      var i = index();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }, { passive: true });
    if (prev) prev.disabled = true;
    car.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
    });
  }

  function openRoute(handle, updateHash) {
    var dlg = document.getElementById('rt-dialog-' + handle);
    if (!dlg || dlg.open) return;
    dlg.showModal();
    document.documentElement.classList.add('rt-lock');
    var car = dlg.querySelector('[data-rt-carousel]');
    if (car) initCarousel(car);
    loadMap(dlg.querySelector('.rt-map[data-route-id]'));
    if (updateHash && history.replaceState) history.replaceState(null, '', '#route-' + handle);
  }

  function initIndex(root) {
    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-route]');
      if (opener) { e.preventDefault(); openRoute(opener.dataset.openRoute, true); return; }

      var dlg = e.target.closest('dialog.rt-dialog');
      if (dlg && (e.target === dlg || e.target.closest('[data-close-route]'))) { dlg.close(); return; }

      var chip = e.target.closest('.rt-chip');
      if (chip) {
        var type = chip.dataset.filter;
        root.querySelectorAll('.rt-chip').forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        root.querySelectorAll('.rt-card').forEach(function (c) {
          c.hidden = type !== 'all' && c.dataset.type !== type;
        });
      }
    });

    root.querySelectorAll('dialog.rt-dialog').forEach(function (dlg) {
      dlg.addEventListener('close', function () {
        document.documentElement.classList.remove('rt-lock');
        if (history.replaceState && location.hash) history.replaceState(null, '', location.pathname + location.search);
      });
    });

    // Open a route from a shared link, e.g. /blogs/routes#route-city-road
    if (location.hash.indexOf('#route-') === 0) {
      var handle = '';
      try { handle = decodeURIComponent(location.hash.slice(7)); } catch (err) {}
      if (handle) openRoute(handle, false);
    }
  }

  function init() {
    document.querySelectorAll('[data-rt-index]').forEach(initIndex);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
